import { isAxiosError } from 'axios';

interface ApiError {
  detail?: string;
}

export function apiErrorMessage(error: unknown, fallback = 'An unexpected error occurred.'): string {
  if (isAxiosError(error)) {
    const detail = (error.response?.data as ApiError | undefined)?.detail;
    if (detail) return detail;
    if (error.message) return error.message;
  }
  return fallback;
}
